import React, { useEffect, useState } from "react";
import axios from "axios";

import "./App.css";
import CryptoList from "./components/cryptolist/CryptoList";
import Navbar from "./components/navbar/Navbar";

const App = () => {
    const [cryptoDetails, setCryptoDetails] = useState([]);
    const [search, setSearch] = useState("");

    // Getting data from API
    useEffect(async () => {
        const cryptoData = await axios.get(
            "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false"
        );
        setCryptoDetails(cryptoData.data);
    }, []);

    // Filtering data with search text
    const filteredArr = cryptoDetails.filter((coin) =>
        coin.name.toLowerCase().includes(search.toLowerCase())
    );
    return (
        <div className='app'>
            <Navbar search={search} setSearch={setSearch} />
            <CryptoList data={filteredArr} />
        </div>
    );
};

export default App;
